import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../../constants/common'
import { RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT } from '../../../../../RentalPortal.constants'
import {
  getIsRentalPortalPageReadCurrent,
  getRentalPortalPageReadKey,
} from '../../../../../RentalPortal.utils'
import { getMockListingViewings } from '../../../../RentalPortalListingViewings.mocks'
import { LISTING_VIEWINGS_PAGE_SIZE } from '../../RentalPortalListingProfileViewings.constants'

// TODO: move onto useTableLoader once the tab reads a served list
export function useListingProfileViewings({ listingId }) {
  const [page, setPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [loadedReadKey, setLoadedReadKey] = useState(null)

  const readIdRef = useRef(0)

  const readKey = getRentalPortalPageReadKey([listingId, page, reloadKey])

  async function loadViewings() {
    readIdRef.current += 1

    const readId = readIdRef.current

    return getMockListingViewings({
      listing_id: listingId,
      page,
      page_size: LISTING_VIEWINGS_PAGE_SIZE,
    })
      .then(({ data }) => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setResponse(data)
          setError(false)
          setPage(data.pagination.page)

          setLoadedReadKey(readKey)
          setInitiated(true)
        }
      })
      .catch(() => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setError(true)

          setLoadedReadKey(readKey)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (listingId) {
      loadViewings()
    }
  }, [readKey])

  function handleSetPagination(nextPagination) {
    setPage(nextPagination.page)
  }

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    handleRefresh,
    handleSetPagination,
    hasError,
    isInitiated,
    isLoading: loadedReadKey !== readKey,
    items: response?.results?.objects ?? EMPTY_LIST,
    pagination: {
      count: response?.pagination?.total ?? RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT,
      page,
      pageCount:
        response?.pagination?.page_count ?? RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT,
      pageSize: LISTING_VIEWINGS_PAGE_SIZE,
    },
  }
}
